import React, { useEffect, useState } from 'react'
import {  useNavigate } from 'react-router-dom';
import { Loader } from '../Common/Loader';
import { sendAdminOtpApi, verifyAdminOtpApi } from '../service/authentication';

const Login = () => {
    const navigate = useNavigate()
    const[loader,setLoader]=useState(false)
    const [otpSent,setOtpSent]=useState(false)
    const [phoneNumber,setPhoneNumber]=useState("")
    const [otp,setOtp]=useState("")

    useEffect(()=>{
   if(localStorage.getItem("access_token")){
    navigate("/")
   }
    },[])

    const handleSendOtp =(e)=>{
        e.preventDefault()
        if(!phoneNumber || phoneNumber.length < 10){
            alert("Please enter a valid 10 digit phone number")
            return
        }
        setLoader(true)
        sendAdminOtpApi({phone_number:phoneNumber}).then((res)=>{
            setLoader(false)
            const responseData = res?.data;
            if(responseData?.status === false){
                alert(responseData?.message || "Failed to send OTP")
                return
            }
            alert(responseData?.message || "OTP sent to your phone number")
            setOtpSent(true)
        }).catch((err)=>{
            setLoader(false)
            console.log("Send OTP error:", err)
            alert(err?.response?.data?.message || "Internal server error")
        })
    }

    const handleVerifyOtp =(e)=>{
        e.preventDefault()
        if(!otp || otp.length !== 6){
            alert("Please enter the 6 digit OTP")
            return
        }
        setLoader(true)
        verifyAdminOtpApi({phone_number:phoneNumber, otp:otp}).then((res)=>{
            setLoader(false)
            const responseData = res?.data;
            if (responseData?.status === false) {
                alert(responseData?.message || "Invalid OTP");
                return;
            }
            const token = responseData?.access_token || responseData?.token || responseData?.data?.access_token;
            if (token) {
                localStorage.setItem("access_token", token);
                window.location.href="/";
            } else {
                alert("Login successful but no token received. Check console for response.");
            }
        }).catch((err)=>{
            setLoader(false)
            console.log("Verify OTP error:", err)
            alert(err?.response?.data?.message || err?.response?.data?.detail || "Internal server error")
        })
    }
  return (
    <>
    {loader?<Loader/>:null}
        <div className='login'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-md-2"></div>
                    <div className="col-lg-6 col-md-8 login-box">
                        <div className="col-lg-12 login-key">
                            <i className="fa fa-key" aria-hidden="true"></i>
                        </div>
                        <div className="col-lg-12 login-title">
                            ADMIN PANEL
                        </div>

                        <div className="col-lg-12 login-form">
                            <div className="col-lg-12 login-form">
                                <form>
                                    {!otpSent ? (
                                        <>
                                            <div className="form-group">
                                                <label className="form-control-label">PHONE NUMBER</label>
                                                <input name="phone_number" type="text" maxLength="10" className="form-control" value={phoneNumber} onChange={(e)=>setPhoneNumber(e.target.value.replace(/\D/g,''))}/>
                                            </div>

                                            <div className="col-lg-12 loginbttm">
                                                <div className="col-lg-6 login-btm login-text">
                                                </div>
                                                <div className="col-lg-6 login-btm login-button">
                                                    <button type="submit" className="btn btn-outline-primary" onClick={handleSendOtp}>SEND OTP</button>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="form-group">
                                                <label className="form-control-label">PHONE NUMBER</label>
                                                <input type="text" className="form-control" value={phoneNumber} disabled/>
                                            </div>
                                            <div className="form-group">
                                                <label className="form-control-label">ENTER OTP</label>
                                                <input name="otp" type="text" maxLength="6" className="form-control" value={otp} onChange={(e)=>setOtp(e.target.value.replace(/\D/g,''))}/>
                                            </div>

                                            <div className="col-lg-12 loginbttm">
                                                <div className="col-lg-6 login-btm login-text">
                                                    <a href="#" onClick={(e)=>{e.preventDefault();setOtpSent(false);setOtp("")}}>Change Number</a>
                                                    {" | "}
                                                    <a href="#" onClick={handleSendOtp}>Resend OTP</a>
                                                </div>
                                                <div className="col-lg-6 login-btm login-button">
                                                    <button type="submit" className="btn btn-outline-primary" onClick={handleVerifyOtp}>VERIFY &amp; LOGIN</button>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </form>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-2"></div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default Login
